"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_PU_REMOTES_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.widgetPu,
    skipImportingInCMS: false,
}, {
    tpdThankYouPage: {
        __mfeName__: "tpdThankYouPage",
        devClientPort: 6012,
        devServerPort: 6112,
    },
    tpdCarrelloVuoto: {
        __mfeName__: "tpdCarrelloVuoto",
        devClientPort: 6013,
        devServerPort: 6113,
    },
    tpdInterpreteAngularDxApiPu: {
        __mfeName__: "tpdInterpreteAngularDxApiPu",
        devClientPort: 7008,
        devServerPort: 7108,
    },
    tpdDisambiguazioneWidget: {
        __mfeName__: "tpdDisambiguazioneWidget",
        devClientPort: 6015,
        devServerPort: 6115,
    },
    tpdMarketingCardWidget: {
        __mfeName__: "tpdMarketingCardWidget",
        devClientPort: 6017,
        devServerPort: 6117,
    },
    tpdRecuperoContattoPreventivoSelezionaContatto: {
        __mfeName__: "tpdRecuperoContattoPreventivoSelezionaContatto",
        devClientPort: 6030,
        devServerPort: 6130,
    },
    tpdRecuperoContattoPreventivo: {
        __mfeName__: "tpdRecuperoContattoPreventivo",
        devClientPort: 6036,
        devServerPort: 6136,
    },
    tpdQuotazioneViaggiWidget: {
        __mfeName__: "tpdQuotazioneViaggiWidget",
        devClientPort: 6038,
        devServerPort: 6138,
    },
    tpdQuotazioneInfortuniWidget: {
        __mfeName__: "tpdQuotazioneInfortuniWidget",
        devClientPort: 6041,
        devServerPort: 6142,
    },
    tpdQuotazioneMalattiaWidget: {
        __mfeName__: "tpdQuotazioneMalattiaWidget",
        devClientPort: 6042,
        devServerPort: 6142,
    },
    tpdCardPuDettaglioPolizza: {
        __mfeName__: "tpdCardPuDettaglioPolizza",
        devClientPort: 6018,
        devServerPort: 6118,
    },
    tpdCardPuPreventivi: {
        __mfeName__: "tpdCardPuPreventivi",
        devClientPort: 6023,
        devServerPort: 6123,
    },
    tpdDettaglioDocumentiPolizzaPu: {
        __mfeName__: "tpdDettaglioDocumentiPolizzaPu",
        devClientPort: 6026,
        devServerPort: 6126,
    },
    tpdListaPreventiviPu: {
        __mfeName__: "tpdListaPreventiviPu",
        devClientPort: 6039,
        devServerPort: 6139,
    },
    tpdListaPreventiviVuota: {
        __mfeName__: "tpdListaPreventiviVuota",
        devClientPort: 6016,
        devServerPort: 6116,
    },
    tpdThankYouPageTelematici: {
        __mfeName__: "tpdThankYouPageTelematici",
        devClientPort: 6014,
        devServerPort: 6114,
    },
    tpdPuDettaglioPolizza: {
        __mfeName__: "tpdPuDettaglioPolizza",
        devClientPort: 6024,
        devServerPort: 6124,
    },
    tpdPuDettaglioPolizzaAmbitoDiBisogno: {
        __mfeName__: "tpdPuDettaglioPolizzaAmbitoDiBisogno",
        devClientPort: 6025,
        devServerPort: 6125,
    },
});
exports.WIDGET_PU_REMOTES_SETTINGS = settings;
